<div class="payment-result success">

  <div class="icon-circle">
    <i class="fa-solid fa-check"></i>
  </div>

  <h1>{{ t('paymentSuccessTitle') }}</h1>

  <p>{{ t('paymentSuccessDesc') }}</p>

  <p class="order-id" *ngIf="orderId">
    Order #{{ orderId }}
  </p>

  <div class="actions">
    <a routerLink="/orders" class="btn primary">{{ t('backToOrders') }}</a>
    <a routerLink="/" class="btn">{{ t('backToHome') }}</a>
  </div>

</div>
